import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  doList:        null,
  soItems:       [],
  soOrderInfo:   null,
  isSoLoading:   false,
  isLoading:     false,
  submitSuccess: null,
  submitError:   null,
};

const complaintsDoSlice = createSlice({
  name: 'complaintsDo',
  initialState,
  reducers: {
    setDoList(state, action) {
      state.doList = action.payload;
      state.isLoading = false;
    },
    setSoItems(state, action) {
      state.soItems = action.payload;
      state.isSoLoading = false;
    },
    setSoOrderInfo(state, action) {
      state.soOrderInfo = action.payload;
    },
    setIsSoLoading(state, action) {
      state.isSoLoading = action.payload;
    },
    setIsLoading(state, action) {
      state.isLoading = action.payload;
    },
    setSubmitSuccess(state, action) {
      state.submitSuccess = action.payload;
      state.isLoading = false;
    },
    setSubmitError(state, action) {
      state.submitError = action.payload;
      state.isLoading = false;
    },
    resetComplaintsDo(state) {
      state.soItems       = [];
      state.soOrderInfo   = null;
      state.isSoLoading   = false;
      state.isLoading     = false;
      state.submitSuccess = null;
      state.submitError   = null;
    },
  },
});

export const {
  setDoList,
  setSoItems,
  setSoOrderInfo,
  setIsSoLoading,
  setIsLoading,
  setSubmitSuccess,
  setSubmitError,
  resetComplaintsDo,
} = complaintsDoSlice.actions;

const complaintsDoReducer = complaintsDoSlice.reducer;
export default complaintsDoReducer;
